import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Button, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import FormItem from '../../../../common/forms/FormItem';
import TextInput from '../../../../common/forms/input/TextInput';
import FormFooter from '../../../../common/forms/FormFooter';
import { isRequired } from '../../../../../utils/validators';
import SupplierSelect from '../../../../common/forms/select/SupplierSelect';
import DynamicForm from '../../../../common/forms/DynamicForm';
import { ADDITIONAL_ITINERARY_FOOD_COLUMNS } from '../../../../../config/dynamicFormFields';

const selector = formValueSelector('AddItineraryFoodForm');

const AddItineraryFoodForm = ({
  handleSubmit,
  handleProcess,
  onCancel,
  loading,
}) => (
  <Form onSubmit={handleSubmit(handleProcess)}>
    <FormGroup row>
      <FormItem label="Proveedor" required>
        <Field
          name="supplierId"
          component={SupplierSelect}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Observaciones" required>
        <Field
          name="observation"
          component={TextInput}
          type="textarea"
          placeholder="Observaciones"
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <h3>Tipo de Alimentación</h3>

    <DynamicForm
      name="itineraryAdditionalFoodTypeList"
      columns={ADDITIONAL_ITINERARY_FOOD_COLUMNS}
    />

    <FormFooter
      saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-save'}
      saveButtonDisabled={loading}
    >
      <Button color="danger" onClick={onCancel}>
        Cancelar
      </Button>
    </FormFooter>
  </Form>
);

AddItineraryFoodForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
  foodSourceType: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

AddItineraryFoodForm.defaultProps = {
  foodSourceType: null,
  loading: false,
};

const mapStateToProps = (state) => ({
  foodSourceType: selector(state, 'foodSourceType'),
  loading: !state.ItineraryUnit.ItineraryAdditionalFood.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'AddItineraryFoodForm',
})(AddItineraryFoodForm);

export default connect(mapStateToProps, null)(formComponent);
